import React, { useContext } from 'react'
import Button from '@/components/Button'
import { PageContext } from '@/utils/context'
import SetCookie from '@/utils/SetCookie'

const RichTextButton = (props) => {

    const { gatedContentAllowed , setCtaReferrer, name } = useContext(PageContext);
    const handleClick = (value) => {
        setCtaReferrer(value)
        SetCookie(`gated_content_redirect_url=${props.target?.cached_url}`)
    }

    return (
        <Button
            before={props.text}
            className={`bg-brightgreen hover:bg-brightgreenhover !text-white !font-semibold before:content-[attr(before)]`}
            to={
                // If not gated content
                !props.gated_content ? props.target?.cached_url :
                // If gated content and gatend content is allowed
                (props.gated_content && gatedContentAllowed) ? props.target?.cached_url
                // If gated content and gated content is not allowed
                : '/download-form/'
            }
            target={props.gated_content && !gatedContentAllowed ? '' : props.target?.linktype !== 'story' ? "_blank" : ''}
            onClick={(props.gated_content && !gatedContentAllowed) ? () => handleClick(`${name}`)  : ''}
        > 
            {props.text}
        </Button>
    )
}

export default RichTextButton